






























import { Vue, Component, Prop } from "@/shared/vuepack";
import { formatDateTimeString } from "@/shared/dateString";
import { useUserNote } from "@/employer/store/userNote";
import Pagination from "@/shared/components/ui/Pagination.vue";
import moment from "moment";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";

interface NoteTableItem {
  createdDate: Date;
  createdBy: string;
  note: string;
  noteToggle?: boolean;
}

@Component({
  components: {
    Pagination,
    AccountHolderWidgetBase
  }
})
export default class AccountHolderNotes extends Vue {
  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  userNoteStore = useUserNote();
  formatDateTimeString = formatDateTimeString;
  allNotes: NoteTableItem[] = [];
  pageNumber = 1;
  pageSize = 10;
  defaultNoteLength = 500;

  loadData () {
    this.userNoteStore.loadUserNotes({
        username: this.username,
        partnerId: this.partnerId
      })
      .then(() => {
        this.initNotes();
      });
  }

  initNotes (): void {
    this.allNotes = [];
    this.userNoteStore.notes.forEach( item => {
      this.allNotes.push({...item, noteToggle: false});
    });
  }

  switchPage (toPage: number): void {
    this.pageNumber = toPage;
  }

  toggleNote (item: NoteTableItem): void {
    item.noteToggle = item.noteToggle ? !item.noteToggle : true;
  }

  noteForDisplay (item: NoteTableItem): string {
    if (!item.note) {
      return "";
    }
    if (item.noteToggle || item.note.length <= this.defaultNoteLength) {
      return item.note;
    }
    return item.note.substring(0, this.defaultNoteLength) + "...";
  }

  get pageCount (): number {
    return Math.ceil(this.allNotes.length / this.pageSize);
  }

  get isLoading (): boolean {
    return this.userNoteStore.isLoading;
  }

  get isLoaded (): boolean {
    return this.userNoteStore.isLoaded;
  }

  get hasData (): boolean {
    return this.isLoaded && this.notes && this.notes.length > 0;
  }

  get notes (): NoteTableItem[] {
    const from = this.pageSize * (this.pageNumber - 1);
    const to = this.pageSize * this.pageNumber;
    return this.allNotes
        .sort((a, b) =>
            moment(b.createdDate).valueOf() - moment(a.createdDate).valueOf()
        )
        .slice(from, to);
  }

  get isFailed () {
    return this.userNoteStore.isFailed;
  }
}
